import { render, staticRenderFns } from "./Redoc.vue?vue&type=template&id=1ba8b5df&"
import script from "./Redoc.vue?vue&type=script&lang=js&"
export * from "./Redoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports